import React from 'react';
import classNames from 'classnames';

import AutGeneralInfoTableA from '../../../blocks/aut-grid-table/autGeneralInfoTableA';
import AutGeneralInfoTableB from '../../../blocks/aut-grid-table/autGeneralInfoTableB';
import CustomSection from '../../custom-general/custom-section';

import { concatClassNames, formatTime } from '../../../../utils/utilities';
import { GeneralInformationData } from '../../../../utils/models';

import classes from './style.module.scss';

interface GridProps {
	title: string;
	value?: string | number;
}

const Grid: React.FC<GridProps> = ({ title, value }) => {
	return (
		<div className="row">
			<div className={classNames([classes.generalInformationGridTitle, 'col-5'])}>
				{title}
			</div>
			<div className={classNames([classes.generalInformationGridValue, 'col'])}>
				{value ?? 'N/A'}
			</div>
		</div>
	);
};

interface ExxonMobilPECGeneralInformationProps extends GeneralInformationData {
	technologyIntroduction: string;
}

const ExxonmobilPECGeneralInformation: React.FC<ExxonMobilPECGeneralInformationProps> = ({ technologyIntroduction, maxwellEquipmentInformation, systemSettings }) => {
	return (
		<CustomSection sectionTitle="General Information">
			<div className="container-fluid overflow-hidden">
				<div className={concatClassNames([classes.technologyIntroduction, 'row'])}>
					<div className={concatClassNames([classes.technologyIntroductionLabel, 'col-4'])}>
						Technology Introduction:
					</div>
					<div className={concatClassNames([classes.technologyIntroductionValue, 'col'])}>
						{technologyIntroduction}
					</div>
				</div>
			</div>

			<div className={classes.generalInformationSection}>
				{maxwellEquipmentInformation?.instrument} Equipment Details
			</div>

			<div className="container-fluid overflow-hidden">
				<div className="row">
					<div className="col">
						<Grid title='Instrument / Manufacturer' value={maxwellEquipmentInformation?.instrument}/>
					</div>
					<div className="col">
						<Grid title='SN' value={maxwellEquipmentInformation?.serialNumber} />
					</div>
				</div>
				<div className="row">
					<div className="col">
						<Grid title='Model' value={ maxwellEquipmentInformation?.model ?? 'N/A'} />
					</div>
					<div className="col">
						<Grid title='Probe Serial Number' value={ maxwellEquipmentInformation?.probeSerialNumber ?? 'N/A'} />
					</div>
				</div>
				<div className="row">
					<div className="col">
						<Grid title='Cable Length (M)' value={maxwellEquipmentInformation?.cableLength?.toString()} />
					</div>
					<div className="col">
						<Grid title='Sizing Algorithm' value={maxwellEquipmentInformation?.sizingAlgo} />
					</div>
				</div>
				<div className="row">
					<div className="col">
						<Grid title='Insulation Type' value={maxwellEquipmentInformation?.insulationType} />
					</div>
					<div className="col">
						<Grid title='Insulation Thickness (mm)' value={maxwellEquipmentInformation?.insulationThickness} />
					</div>
				</div>
				<div className="row">
					<div className="col">
						<Grid title='Calibration Due Date' value={maxwellEquipmentInformation?.calibrationDueDate ? formatTime(maxwellEquipmentInformation?.calibrationDueDate, 'MMM DD, YYYY') : 'N/A'} />
					</div>
					<div className="col">
						<Grid title='Date of Inspection' value={maxwellEquipmentInformation?.dateOfInspection ? formatTime(maxwellEquipmentInformation?.dateOfInspection, 'MMM DD, YYYY') : 'N/A'} />
					</div>
				</div>

				<Grid title='Footprint' value={maxwellEquipmentInformation?.footprint} />
			</div>

			<div className={classes.generalInformationSection}>System Settings</div>

			<div className="container-fluid overflow-hidden">
				<div className="row p-1">
					<div className="col p-0"><AutGeneralInfoTableA {...systemSettings} /></div>
					<div className="col p-0"><AutGeneralInfoTableB {...systemSettings} /></div>
				</div>
			</div>
		</CustomSection>
	);
};

export default ExxonmobilPECGeneralInformation;
